import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import Cropper from 'react-easy-crop'
import UploadCropImagePopup from '../UploadCropImagePopup'

export const GolfHubAddPhotoPopup = (props) => {
  const [ imagePreview, setImagePreview ] = useState({ image: '', crop: ''})
  const [ disableImageSave, sedDisableImageSave ] = useState(true)
  const [ crop, setCrop ] = useState({ x: 0, y: 0 })
  const [ zoom, setZoom ] = useState(1)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    if (imagePreview.image) {
      setImagePreview({image: imagePreview.image, imageFile: imagePreview.imageFile, crop: croppedAreaPixels})
    }
  }, [ imagePreview.image ])

  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    setImagePreview({image: URL.createObjectURL(file), imageFile: file, crop: ''})

    let message = ''
    if (file.size > 6000000) { // bytes
      message = window.I18n.t('views.golfhub.upload_errors.file_too_large')
    }

    if ([ 'image/jpeg', 'image/png', 'image/gif', 'image/bmp' ].indexOf(file.type) < 0) {
      message += window.I18n.t('views.golfhub.upload_errors.invalid_format')
    }

    if (message !== '') {
      $('.error-message').removeClass('hidden')
      $('.error-message').html(message)
      sedDisableImageSave(true)

    } else {
      $('.error-message').addClass('hidden').disabled = false
      sedDisableImageSave(false)
    }
  }

  const handleModalClose = () => {
    props.setModalOpen(false)
    setImagePreview({ image: '', crop: ''})
  }

  const saveImage = () => {
    props.setImages([ ...props.images, imagePreview ])
    handleModalClose()
  }

  return (
    <UploadCropImagePopup
      isOpen={props.modalOpen}
      onClose={() => handleModalClose()}
      onConfirm={() => saveImage()}
      isConfirmDisabled={!imagePreview.image || disableImageSave}
      confirmText={window.I18n.t('views.golfhub.banners_new.done')}
      title={window.I18n.t('views.golfhub.banners_new.upload_image')}
      imagePreviewSrc={imagePreview.image}
      imagePreviewComponent={
        <div className='crop-container'>
          <Cropper
            image={imagePreview.image}
            crop={crop}
            zoom={zoom}
            aspect={6 / 1.25}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom} />
        </div>}
      imagePreviewHeader={window.I18n.t('views.golfhub.banners_new.banner_preview_header')}
      imagePreviewDetails={window.I18n.t('views.golfhub.image_preview_details')}
      handleImageUpload={handleImageUpload}
      photoFormats={window.I18n.t('views.golfhub.accepted_formats')}
      photoRequirements={window.I18n.t('views.golfhub.banners_new.acceptable_format')}
      uploadLabel={window.I18n.t('views.golfhub.upload_crop_image.upload_banner')}
    />
  )
}

GolfHubAddPhotoPopup.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  images: PropTypes.array,
  setImages: PropTypes.func,
}
